<template>
  <div :class="['page-header', layout, pageWidth]">
    <div class="page-header-wide">
      <div class="breadcrumb">
        <a-breadcrumb>
          <a-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index">
            <span>{{item}}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="detail">
        <div class="main">
          <div class="row">
            <h1 v-if="showPageTitle && title" class="title">{{title}} 
              <!-- <a-tag v-if="isShow" class="textStyle" color="green">
                {{text}}
              </a-tag> -->
              </h1>
            <div class="action"><slot name="action"></slot></div>
          </div>
          <div class="row">
            <div v-if="this.$slots.content" class="content">
              <div v-if="avatar" class="avatar"><a-avatar :src="avatar" :size="72" /></div>
              <slot name="content"></slot>
            </div>
            <div v-if="this.$slots.extra" class="extra"><slot name="extra"></slot></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { EventBus } from '@/utils/event-bus'

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: [String, Boolean],
      required: false,
      default: ''
    },
    breadcrumb: {
      type: Array,
      required: false,
      default: ()=>[]
    },
    logo: {
      type: String,
      required: false,
      default: ''
    },
    avatar: {
      type: String,
      required: false,
      default: ''
    },
  },
  data(){
    return {
      isShow: false,
      text: ''
    }
  },
  computed: {
    ...mapState('setting', ['layout', 'showPageTitle', 'pageWidth'])
  },
  mounted(){
    EventBus.$on('orderTypeShow', (data)=>{
      this.isShow = true
      this.text = data
    })
    EventBus.$on('orderTypeHidde', ()=>{
      this.isShow = false
    })
  },
  beforeDestroy(){
    EventBus.$off('orderTypeShow')
  }
}
</script>

<style lang="less" scoped>
  @import "index";
  .textStyle{
    font-size: 14px;
    font-weight: 500;
  }
  .page-header-wide{
    // background-color: #fff;
    padding-top: 10px;
    padding-left: 30px;
  }
</style>
